import * as React from 'react';
import * as I18n from 'i18n-js';

import NewsletterSignup from '@reverbdotcom/commons/dist/components/newsletter_signup';

interface IProps {
  signupReason: string;
}

export default function HomepageNewsletter({ signupReason }: IProps) {
  return (
    <div className="homepage-newsletter">
      <div className="homepage-newsletter__container">
        <div className="homepage-newsletter__image-container">
          <div className="homepage-newsletter__image" />
        </div>
        <div className="homepage-newsletter__form">
          <NewsletterSignup
            title={I18n.t('discovery.newsletterSignup.title')}
            subtitle={I18n.t('discovery.newsletterSignup.subtitle')}
            signupReason={signupReason}
          />
        </div>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/homepage_newsletter.tsx